define((require) => {
    "use strict";

    var Marionette       = require("marionette"),
        template         = require("ui/assets/youtube/YouTubeImageView.tpl"),
        YouTubeImageView = require("ui/assets/youtube/YouTubeImageView");

    /**
     * The collection view of share recipients.
     *
     * @author Antonio Lagrotteria
     * @class YouTubeCollectionView
     * @constructor
     */
    return Marionette.CollectionView.extend({
        template: template,
        itemView: YouTubeImageView
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/assets/youtube/YouTubeImageCollectionView.js